// extracted by mini-css-extract-plugin
module.exports = {"videoContainer":"gttl-beloved-home_videoContainer__jqwbJ"};